import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  /** Defaults to the pricing card. Only the pricing card links to checkout. */
  href?: string;
  className?: string;
  size?: 'lg' | 'sm';
};

/**
 * Highlighter yellow is the single action colour on this page, against the
 * Track Navy. Infield green marks what's included; Track Clay is kept for
 * tension and safety cues.
 */
export function CtaButton({
  children,
  href = '#offer',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-6 py-5 text-lg sm:text-xl rounded-2xl min-h-[64px]' : 'px-5 py-3 text-sm rounded-xl';
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!href.startsWith('#')) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({
      behavior: reduce ? 'auto' : 'smooth',
      block: 'start'
    });
  };
  return <a href={href} target={href.startsWith('#') ? undefined : '_top'} onClick={handleClick} className={`inline-flex w-full items-center justify-center gap-2 bg-hl text-center font-display font-bold uppercase tracking-wide text-hl-ink shadow-card transition-[background-color,box-shadow] duration-150 ease-out hover:bg-hl-hover hover:shadow-lift focus:outline-none focus-visible:ring-4 focus-visible:ring-chalk/70 ${sizing} ${className}`} data-id="element-117" data-mp="35yh9e472n85q">
      {children}
    </a>;
}